import { TrackingEvent } from 'client/tracking/event';
import { CommonMap } from 'client/tracking/maps/common';
import { TrackingConstant } from 'client/tracking/constant';

const map = {
  wr_change_vehicle: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_CONFIGURE_VEHICLE,
    TrackingConstant.CHANGE_VEHICLE
  ),
  wr_review_another_vehicle: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_CONFIGURE_VEHICLE,
    TrackingConstant.REVIEW_ANOTHER_VEHICLE
  ),
  wr_see_cars_value: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_VIEW_CONTENT,
    TrackingConstant.SEE_CARS_VALUE
  ),
  wr_research_new_cars: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_VIEW_CONTENT,
    TrackingConstant.RESEARCH_NEW_CARS
  ),
  wr_discuss_cars: TrackingEvent.actionCompleted(TrackingConstant.ACTION_VIEW_CONTENT, TrackingConstant.DISCUSS_CARS),
  wr_submit_step_1: TrackingEvent.actionCompleted(TrackingConstant.ACTION_WRITE_REVIEW, 'submit_review_step1'),
  wr_submit_step_2: TrackingEvent.actionCompleted(TrackingConstant.ACTION_WRITE_REVIEW, 'submit_review_step2'),
  wr_submit_step_3: TrackingEvent.actionCompleted(TrackingConstant.ACTION_WRITE_REVIEW, 'submit_review_step3'),
  wr_submit_step_4: TrackingEvent.actionCompleted(TrackingConstant.ACTION_WRITE_REVIEW, 'submit_review_step4'),
  wr_begin_sign_up: TrackingEvent.actionStart(TrackingConstant.ACTION_SIGN_UP, TrackingConstant.BEGIN_SIGN_UP, {
    action_cause: 'page_load',
  }),
  wr_save_vehicle_review: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_SAVE_VEHICLE,
    TrackingConstant.SAVE_VEHICLE_REVIEW,
    {
      action_cause: 'button_click',
    }
  ),
};

export const TrackingMap = {
  ...CommonMap,
  ...map,
};
